// Variant Value Display for Number of Blades and Number of Lights
document.addEventListener('DOMContentLoaded', function() {
  // Function to update value display
  function updateValueDisplay(optionSelector, value) {
    const legend = optionSelector.querySelector('legend.label');
    if (!legend) return;
    
    const labelText = legend.childNodes[0].textContent.trim();
    if (labelText === 'Number of Blades' || labelText === 'Lights' || labelText === 'Finishes') {
      const valueSpan = legend.querySelector('.value-attribute');
      if (valueSpan) {
        valueSpan.textContent = value;
      }
    }
  }
  
  // Handle radio button selections (for button style variants)
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('opt-btn') && e.target.type === 'radio') {
      const optionSelector = e.target.closest('[data-single-option-selector]');
      if (optionSelector) {
        updateValueDisplay(optionSelector, e.target.value);
      }
    }
  });
  
  // Handle dropdown selections
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cc-select__option')) {
      const option = e.target.closest('.cc-select__option');
      const selectWrapper = option.closest('.cc-select');
      const optionSelector = selectWrapper ? selectWrapper.closest('[data-single-option-selector]') : null;
      const value = option.getAttribute('data-value');
      
      if (optionSelector && value) {
        // Update the label if it exists outside the cc-select
        const label = optionSelector.querySelector('label.label .value-attribute');
        if (label) {
          const labelText = label.parentElement.childNodes[0].textContent.trim();
          if (labelText === 'Number of Blades' || labelText === 'Lights' || labelText === 'Finishes') {
            label.textContent = value;
          }
        }
        
        // Update the label if it's inside the cc-select
        const internalLabel = selectWrapper.querySelector('label.label .value-attribute');
        if (internalLabel) {
          const labelText = internalLabel.parentElement.childNodes[0].textContent.trim();
          if (labelText === 'Number of Blades' || labelText === 'Lights' || labelText === 'Finishes') {
            internalLabel.textContent = value;
          }
        }
      }
    }
  });
  
  // Also handle the custom select's built-in update mechanism
  if (window.theme && window.theme.CustomSelect) {
    const originalUpdateSelection = window.theme.CustomSelect.prototype.updateSelection;
    window.theme.CustomSelect.prototype.updateSelection = function(selectedOption) {
      originalUpdateSelection.call(this, selectedOption);
      
      // Find the parent option selector
      const optionSelector = this.container.closest('[data-single-option-selector]');
      if (optionSelector) {
        const value = selectedOption.getAttribute('data-value');
        const label = optionSelector.querySelector('label.label') || this.container.querySelector('label.label');
        if (label && value) {
          const labelText = label.childNodes[0].textContent.trim();
          if (labelText === 'Number of Blades' || labelText === 'Lights') {
            const valueSpan = label.querySelector('.value-attribute');
            if (valueSpan) {
              valueSpan.textContent = value;
            }
          }
        }
      }
    };
  }
});
